import React from "react";

import { YaasPositionStatus } from "../../types/yaasPositions";
import type { LifecycleStatusTone } from "../console/badges";
import { IndicationUnit } from "../Metrics/IndicationUnit";

const STATUS_VARIANT: Record<YaasPositionStatus, LifecycleStatusTone> = {
    [YaasPositionStatus.Pending]: "pending",
    [YaasPositionStatus.Active]: "success",
    [YaasPositionStatus.Rejected]: "error",
    [YaasPositionStatus.Suspended]: "pending",
    [YaasPositionStatus.Disabled]: "disabled",
    [YaasPositionStatus.Hidden]: "disabled"
};

const TONE_TEXT: Record<LifecycleStatusTone, string> = {
    success: "text-success-base",
    pending: "text-warning-base",
    error: "text-error-base",
    disabled: "text-foreground-muted"
};

interface YaasPositionStatusBadgeProps {
    status: YaasPositionStatus;
    className?: string;
}

/**
 * Position status as the canonical bare indicator — a blinking
 * `IndicationUnit` status dot beside the tone-colored label. No
 * pill/surface/border (the chrome lives on `LifecycleStatusBadge` for
 * contexts that still want a box).
 */
export function YaasPositionStatusBadge({
    status,
    className
}: YaasPositionStatusBadgeProps): React.ReactElement {
    const tone = STATUS_VARIANT[status];
    return (
        <span
            className={`inline-flex items-center gap-1.5 whitespace-nowrap${
                className ? ` ${className}` : ""
            }`}
        >
            <IndicationUnit variant="status" state={tone} size={7} />
            <span
                className={`font-sans text-xs leading-4 tracking-normal ${TONE_TEXT[tone]}`}
            >
                {status}
            </span>
        </span>
    );
}
